import {
    // FETCH_ACTIVITY_NOTIFICATION_REQUEST,
    REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST,
    FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST,
    VALIDATE_CHANGE_ACTIVITY_ASSIGNEE,
    BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST,
    CLEAR_VALIDATION_ERROR_MESSAGE,
    SHOW_TOAST_WITH_PROPS,
    HIDE_TOAST,
    RESET_CHANGE_ACTIVITY_ASSIGNEE_STATE,
    FETCH_USER_INFO,
    FETCH_MULTIPLE_PROFILES


} from "../../SpockViewPage/actions/actionConstants";

import {
    HIDE_TOOLTIP,
    SHOW_TOOLTIP
} from "../../../components/Tooltip/constants"

export const showTooltip = (payload) => ({
    type: SHOW_TOOLTIP,
    payload
});

export const hideTooltip = () => ({
    type: HIDE_TOOLTIP
});

// reassign activity from views
export const getActivityAssigneeUsers = (payload => ({
    type: FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST,
    payload
}));

export const reassignActivityFromView = (payload) => ({
    type : REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST,
    payload
});

export const getValidChangeActivityAssigneeInfo = (payload) => ({
    type : VALIDATE_CHANGE_ACTIVITY_ASSIGNEE,
    payload
});

export const bulkReassignActivitiesFromViews = (payload) => ({
    type: BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST,
    payload
});

export const clearErrorValidationMessage = () => ({
    type:CLEAR_VALIDATION_ERROR_MESSAGE
});

export const setErrorValidationMessage = () => ({
    type: SET_VALIDATION_ERROR_MESSAGE
});

export const getUserInfo = (payload) => ({
    type: FETCH_USER_INFO,
    payload
});

export const getMultipleProfile =(payload) => ({
    type:FETCH_MULTIPLE_PROFILES,
    payload
})

export const showToast = (payload) => ({
    type:SHOW_TOAST_WITH_PROPS,
    payload
});

export const hideToast = () => ({
    type:HIDE_TOAST
});

export const resetChangeActivityAssigneeState = () => ({
    type:RESET_CHANGE_ACTIVITY_ASSIGNEE_STATE
})
